export default __webpack_public_path__ + "static/media/icon_counter.d6614dce.svg";